import Logo from "../items/Logo"
import facebook_icon from '../../assets/facebook.png'
import linkedin_icon from '../../assets/linkedin.png'
import twitter_icon from '../../assets/twitter.png'
import AppContext from "../../context/AppContext"
import { useContext } from "react"
import { Link } from "react-router-dom"

function Footer() {
    const { blur } = useContext(AppContext)

  return (
    <footer className={`${blur ? 'blur' : ''}`}>
        <div className="content">
            <div className="contacts">
                <Link to='/' className="logo">
                    <Logo/>
                </Link>
                <div className="details">
                    <span>Phone: +234 9000453289</span>
                    <span>Email: info@Medbolt.com</span>
                </div>
            </div>
            <div className="legal">
                <h3>LEGAL</h3>
                <Link>Privacy Policy</Link>
                <Link>Terms of Service</Link>
            </div>
            <div className="socials">
                <h3>FOLLOW US</h3>
                <div className="icons">
                    <a href="#"><img src={facebook_icon} alt="facebook icon" /></a>
                    <a href="#"><img src={linkedin_icon} alt="linkedin icon" /></a>
                    <a href="#"><img src={twitter_icon} alt="twitter icon" /></a>
                </div>
            </div>
        </div>
        <small>All Rights Reserved. &copy;2023 MedBolt</small>
    </footer>
  )
}

export default Footer